import { Suspense, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import { getRoutesConfig } from '@app/configs/router';
import { Layout } from 'antd';
import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  min-height: 100dvh;
  width: 100%;
`;

const LoadingFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  width: 100%;
  background: #000;
  color: #fff;
`;

const Router = () => {
  const routesConfig = useMemo(() => getRoutesConfig(), []);

  return (
    <Routes>
      {Object.values(routesConfig).map(({ sideBar: SideBar, navBar: NavBar = () => null, ...route }) =>
        SideBar ? (
          <Route
            {...route}
            key={route.path}
            element={
              <Layout>
                <SideBar />
                <Content>
                  <NavBar />
                  <Suspense fallback={<LoadingFallback>Loading...</LoadingFallback>}>{route.element}</Suspense>
                </Content>
              </Layout>
            }
          />
        ) : (
          <Route
            {...route}
            key={route.path}
            element={
              <Content>
                <NavBar />
                <Suspense fallback={<LoadingFallback>Loading...</LoadingFallback>}>{route.element}</Suspense>
              </Content>
            }
          />
        ),
      )}
    </Routes>
  );
};

export { Router };
